/**
 * Aritmética monetária em CENTAVOS (inteiros).
 *
 * Regra do projeto (§11.15): o banco guarda NUMERIC(12,2); o driver `pg`
 * devolve NUMERIC como string; a borda converte para inteiro em centavos e
 * TODA a aritmética acontece em inteiro. A API trafega `*Centavos`.
 * Nenhum `parseFloat` em valor monetário — elimina 0.1 + 0.2 !== 0.3.
 */
/** Converte NUMERIC (string do driver pg), número ou null para centavos inteiros. */
export function paraCentavos(valor) {
    if (valor == null)
        return 0;
    if (typeof valor === 'number') {
        if (!Number.isFinite(valor))
            return 0;
        return Math.round(valor * 100);
    }
    const bruto = valor.trim();
    if (bruto === '')
        return 0;
    const negativo = bruto.startsWith('-');
    const semSinal = negativo ? bruto.slice(1) : bruto;
    const [inteiroRaw = '0', decimalRaw = ''] = semSinal.split('.');
    const inteiro = inteiroRaw.replace(/\D/g, '') || '0';
    const decimal = (decimalRaw.replace(/\D/g, '') + '00').slice(0, 2);
    const centavos = Number(inteiro) * 100 + Number(decimal);
    return negativo ? -centavos : centavos;
}
/** Centavos → string NUMERIC pronta para o banco ('40000' → '400.00'). */
export function centavosParaNumeric(centavos) {
    const n = Math.trunc(centavos);
    const sinal = n < 0 ? '-' : '';
    const abs = Math.abs(n);
    return `${sinal}${Math.trunc(abs / 100)}.${String(abs % 100).padStart(2, '0')}`;
}
/** Centavos → número decimal (use apenas para exibição/gráficos, nunca para somar). */
export function centavosParaDecimal(centavos) {
    return Math.trunc(centavos) / 100;
}
/** Formata centavos como moeda brasileira: 40000 → 'R$ 400,00'. */
export function formatarBRL(centavos) {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(centavosParaDecimal(centavos));
}
/** Formata centavos sem o símbolo: 40000 → '400,00'. */
export function formatarValor(centavos) {
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(centavosParaDecimal(centavos));
}
/**
 * Máscara de digitação em centavos — replica `handleCurrencyInput` das telas
 * atuais: o operador digita `15000` e o campo mostra `150,00`.
 */
export function aplicarMascaraMoeda(valor) {
    const digitos = valor.replace(/\D/g, '');
    if (digitos === '')
        return '';
    return formatarValor(Number(digitos));
}
/** Lê um campo mascarado ('1.500,00') de volta para centavos (150000). */
export function mascaraParaCentavos(valor) {
    const digitos = valor.replace(/\D/g, '');
    return digitos === '' ? 0 : Number(digitos);
}
/** Soma segura de centavos. */
export function somarCentavos(...valores) {
    return valores.reduce((acc, v) => acc + Math.trunc(v || 0), 0);
}
//# sourceMappingURL=money.js.map